import { render } from "./single_applicant.vue?vue&type=template&id=3dffb19d&scoped=true"
import script from "./single_applicant.vue?vue&type=script&lang=js"
export * from "./single_applicant.vue?vue&type=script&lang=js"

import "./single_applicant.vue?vue&type=style&index=0&id=3dffb19d&scoped=true&lang=css"

import exportComponent from "/var/www/EasternFront_new/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3dffb19d"]])

export default __exports__